module.exports = __webpack_public_path__ + "img/12塑料工业.c5fccae5.jpg";